import { render, staticRenderFns } from "./Landscaping.vue?vue&type=template&id=61cba080&"
import script from "./Landscaping.vue?vue&type=script&lang=js&"
export * from "./Landscaping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports